<template>
<div class="text-center my-0 py-0">
  <v-row no-gutters justify="center" align="center" id='jumbotron'>
    <v-col xs="12" class='text-xs-center' style='min-width: 800px;'>
      <v-card id='mainTitle' tile hover class='px-5 py-3' width='100%' height='100%'>
        <h2 class='jumbotronText display-3 amber--text'>Regenerative Building Simulator</h2>
        <h2 class='jumbotronText title amber--text my-2 font-weight-bold'>by ASDL</h2>
      </v-card>
    </v-col>
  </v-row>

  <v-layout py-2 v-for='(x, i) in keyDesc' :key='i' justify="center" style='padding-left: 60px !important; padding-right: 60px !important; '>
    <v-flex xs="12" lg="11" xl="10">
      <v-layout wrap>
        <v-flex xs12 md9 pr-3>
          <v-layout wrap>
            <v-flex xs1 style='max-width: 88px;' d-flex py-4>
              <v-btn fab outlined large color='primary'>
                <v-icon dark>{{ x.icon }}</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs10>
              <v-card flat>
                <v-card-title mb-2 class='display-1 bold text-start text-wrap' style="word-break:normal">{{x.title}}</v-card-title>
                <v-card-text class='text-start title font-weight-regular text-color-black text--primary'>{{x.desc}}</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md3 style='width: 200px'>
          <v-img :src='require(`../assets/image/intro0${ i + 1 }.png`)' :lazy-src='require("../assets/image/intro01.png")' :width='200' />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

</div>
</template>


<script>

export default {
  data: () => ({
    btnItems: [
      { title: 'Official Website', tooltip: 'Go to KENDEDA website' },
      { title: 'Kendeda Portal',   tooltip: 'Explore the dashboard' }
    ],
    keyDesc: [
      { icon: 'description', title: "Kendeda living building challenge meets digital engineering", desc: "Digital engineering is one of trending engineering paradigms incorporating conventional physics-based approach with data-driven study. ASDL's digital enginering technology is finely elaborated to fully optimize the sustainability and net-neutrality of the Kendeda living building." },
      { icon: 'bar_chart', title: "Enhanced Visualization by ASDL's Technology", desc: "For the maximum articulation of data information retrieved from kendeda building, various innovative big-data visualization tools are used by the power of Echarts, a performant and feature-rich javascript library for rapid data visualization and analytics. Echarts provides not only conventional charts but also lots of advanced visualizations such as sankey diagram, etc." },
      { icon: 'build', title: 'Flexible & Customizable Data Exploration', desc: "KENdeda building Digital Engineeg & Data Analytics is featured with a highly customizable data analysis and exploration framework. In this framework, a huge amount of complex dataset can be easily analyzed and simulated in various multi-dimensional and simultaneous graphic interface." },
    ]
  }),
  computed: {

  },
  methods: {
    onBtn(i) {
      return i ? this.$router.push('/dashboard') : window.open('https://livingbuilding.gatech.edu/')
    }
  },
}
</script>


<style lang='stylus' scoped>

#explorerTitle
  font-family: 'Poppins' !important
  font-weight: bold
  text-align: center
  font-size: 4rem
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5)
  color: #DFDFDF
  line-height: 1.2
  text-transform: uppercase

  .ex-title
    font-size: 7rem !important

  .affiliation
    margin-top: 0.5rem
    text-transform: none
    font-size: 1.2rem


.index-video-wrapper
  position: relative
  width: 100vw

  #vid
    height: 100vh
    width: 110vw
    object-fit: fill
    z-index: -100
    margin-left: -5vw
    right: 0
    bottom: 0
    background: url('../assets/LBC1.png') no-repeat center center
    background-size: cover
    overflow: hidden

#mainTitle
    background: url('../assets/parallax.png') no-repeat center center
    background-size: cover
    height: 100%
    overflow: hidden

</style>
